module.exports = __webpack_public_path__ + "img/people1.1ac963fa.png";